import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

const borderGradient = `border: 16px solid rgb(255, 255, 255);
  border: 16px solid rgba(255, 255, 255, 0.5);
  border-radius: 3px;
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */`

export const LoginWrapper = styled.div`
  width: 440px;
  background-color: ${({ theme }) => theme.colors.white};

  ${borderGradient}

  ${mediaQueries.tablet`
   width: 370px;
  `};

  ${mediaQueries.mobile`
   width: 100%;
   height: 100%;
    border: none;
  `};
`

export const SearchboxWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 15px 25px;
  ${borderGradient}

  ${mediaQueries.mobile`
   width: 100%;
  `};
`

export const InfoText = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsInfoTextBox')
}))`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fonts.regular};
  ${mediaQueries.tablet`
    padding-right: 0;
  `};
  ${mediaQueries.mobile`
    padding: 24px 16px;
     background-color: ${({ theme }) => theme.colors.gray10};
  `};
`

export const InfoTextTitle = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsInfoTextTitle')
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
  font-size: 22px;
  padding-bottom: 16px;
  ${mediaQueries.mobile`
     font-size: 18px;
  `};
`

export const FormContainer = styled.div`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 22px;
  width: 100%;
  justify-content: center;
`

export const InputContainer = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.inputBox')}${props.e2eClass}`
}))`
  ${({ noFlex, flex }) =>
    !noFlex &&
    `
      display: flex;
      flex: ${flex || 0.32};
  `}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignSelf }) => alignSelf && `align-self: ${alignSelf};`}
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ flexWrap }) => flexWrap && `flex-wrap: ${flexWrap};`}
  
  ${mediaQueries.mobile`
    flex: 1;
    flex-basis: 100%;
  `}
`
export const SubmitButtonContainer = styled.div`
  flex: 0.32;
  margin-bottom: 40px;
  ${mediaQueries.mobile`
    flex: 1;
  `}
`

export const InputRow = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.inputTitle')}${props.e2eClass}`
}))`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 18px;
  align-items: flex-start;
  justify-content: space-between;
  ${({ isLast }) =>
    isLast &&
    `
    margin-bottom: 32px;
  `}
  ${({ width }) => width && `width: ${width};`}
  ${mediaQueries.mobile`
    width: 100%;
  `}
`

export const FeedbackContainer = styled.div`
  display: flex;
  ${({ noMargin }) => !noMargin && `margin-bottom: 32px;`}
`
export const FeedbackTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.bold};
  ${({ margin }) => margin && `margin: ${margin};`}
`
